import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle,
    //------------- globalStates
    globalStates,
    //------------- defalutData 
    defaultData,
    //------------- Helpers
    Helpers,
    //------------- Forms
    Forms,
    //------------- FetchData
    FetchData
}) => {

    const _fetchTransactionByFilter = async ({ startDate, endDate, idcaja, movimiento_tipo }) => {
        if (!startDate) return
        if (!endDate) return

        const normalized = {
            startDate,
            endDate,
            idcaja: (!idcaja || idcaja === 'ALL') ? '' : idcaja,
            movimiento_tipo: (!movimiento_tipo || movimiento_tipo === 'MOVIMIENTOS') ? 'ALL' : movimiento_tipo
        }

        const { fetchAllTranscationsCasher } = FetchData
        fetchAllTranscationsCasher.setParamsToSearch(normalized)
        fetchAllTranscationsCasher.executeFetch()
    }

    const _calculateTotalQuetzalsAndDollars = ({
        refSetFormState,
        movimiento_moneda,
        clean_movimiento_monto,
        clean_movimiento_tipo_cambio,
        formatMoney,
    }) => {
        const monto = Number(clean_movimiento_monto);
        const tc = Number(clean_movimiento_tipo_cambio);

        if (!movimiento_moneda || isNaN(monto) || isNaN(tc) || tc === 0) {
            refSetFormState(prev => ({
                ...prev,
                movimiento_quetzales: '',
                movimiento_dolares: '',
                clean_movimiento_quetzales: 0,
                clean_movimiento_dolares: 0,
            }));
            return;
        }

        let q = 0;
        let usd = 0;

        if (movimiento_moneda === 'QUETZAL') {
            q = monto;
            usd = 0;
        } else if (movimiento_moneda === 'DOLAR') {
            usd = monto;
            q = 0;
        } else {
            return;
        }

        refSetFormState(prev => ({
            ...prev,

            movimiento_quetzales: formatMoney(q),
            movimiento_dolares: formatMoney(usd),

            clean_movimiento_quetzales: Number(q.toFixed(2)),
            clean_movimiento_dolares: Number(usd.toFixed(2)),
        }));
    };

    const abrirModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }

    const cerrarModal = () => {
        toggle()
    }

    const handleClickShowForm = (flag) => {
        const { setShowForm } = globalStates
        setShowForm(flag)
    }

    const handleClickHideForm = () => {

        const { FormScreen } = Forms
        const { onResetForm } = FormScreen

        onResetForm()
        handleClickShowForm(false)

    }

    const handleClickFetchSpecificTransactionCashier = async (idmovimiento, modalOpeningMode) => {

        const { FormScreen } = Forms
        const { onResetForm } = FormScreen

        const { fetchSpecificTransactionCashier } = FetchData
        const { setModalOpeningMode } = globalStates

        onResetForm()

        fetchSpecificTransactionCashier.setParamsToSearch({ idmovimiento: idmovimiento })
        fetchSpecificTransactionCashier.executeFetch()

        handleClickShowForm(true)
        setModalOpeningMode(modalOpeningMode)

    }

    const handleClickOpenEditableForm = async (flag, modalOpeningMode) => {
        const { setModalOpeningMode } = globalStates
        handleClickShowForm(flag)
        setModalOpeningMode(modalOpeningMode)
    }

    const handleChangeStartDate = (event) => {
        const { FilterForm } = Forms
        const { formState, setFormState } = FilterForm

        const { name, value } = event.target
        setFormState(prevState => ({
            ...prevState,
            [name]: value,
        }))

        const { endDate, idcaja, movimiento_tipo } = formState
        _fetchTransactionByFilter({
            startDate: value,
            endDate,
            idcaja,
            movimiento_tipo: movimiento_tipo || 'ALL'
        })
    }

    const handleChangeEndDate = (event) => {
        const { FilterForm } = Forms
        const { formState, setFormState } = FilterForm

        const { name, value } = event.target
        setFormState(prevState => ({
            ...prevState,
            [name]: value,
        }))

        const { startDate, idcaja, movimiento_tipo } = formState
        _fetchTransactionByFilter({
            startDate,
            endDate: value,
            idcaja,
            movimiento_tipo: movimiento_tipo || 'ALL'
        })
    }

    const handleChangeIdCaja = (event) => {
        const { FilterForm } = Forms
        const { formState, setFormState } = FilterForm

        const { name, value } = event.target
        setFormState(prevState => ({
            ...prevState,
            [name]: value,
        }))

        const { startDate, endDate, movimiento_tipo } = formState
        _fetchTransactionByFilter({
            startDate,
            endDate,
            idcaja: value,
            movimiento_tipo: movimiento_tipo || 'ALL'
        })
    }

    const handleChangeMovimientoTipo = (event) => {
        const { FilterForm } = Forms
        const { formState, setFormState } = FilterForm

        const { name, value } = event.target
        setFormState(prevState => ({
            ...prevState,
            [name]: value,
        }))

        const { startDate, endDate, idcaja } = formState
        _fetchTransactionByFilter({
            startDate,
            endDate,
            idcaja,
            movimiento_tipo: value || 'ALL'
        })
    }

    const handleChangeAmount = (event) => {
        const { FormScreen } = Forms;
        const { formState, setFormState, onInputChangeForNumber } = FormScreen;
        const { formatMoney } = Helpers;

        onInputChangeForNumber(event);

        const clean_value = Helpers.convertToFloat(event.target.value);

        setFormState(prev => ({
            ...prev,
            clean_movimiento_monto: clean_value,
        }));

        if (formState.movimiento_moneda && formState.clean_movimiento_tipo_cambio) {
            _calculateTotalQuetzalsAndDollars({
                refSetFormState: setFormState,
                movimiento_moneda: formState.movimiento_moneda,
                clean_movimiento_monto: clean_value,
                clean_movimiento_tipo_cambio: formState.clean_movimiento_tipo_cambio,
                formatMoney,
            });
        }

        setFormState(prev => ({
            ...prev,
            clean_movimiento_monto: clean_value,
        }));
    };

    const handleChangeTypeCurrency = (event) => {
        const { FormScreen } = Forms;
        const { formState, setFormState } = FormScreen;
        const { formatMoney } = Helpers;

        const { name, value } = event.target;
        setFormState(prev => ({ ...prev, [name]: value }));

        if (formState.clean_movimiento_monto && formState.clean_movimiento_tipo_cambio) {
            _calculateTotalQuetzalsAndDollars({
                refSetFormState: setFormState,
                movimiento_moneda: value,
                clean_movimiento_monto: formState.clean_movimiento_monto,
                clean_movimiento_tipo_cambio: formState.clean_movimiento_tipo_cambio,
                formatMoney,
            });
        }
    };

    const handleChangeExchangeRate = (event) => {
        const { FormScreen } = Forms;
        const { formState, setFormState, onInputChangeForNumber } = FormScreen;
        const { formatMoney, convertToFloat } = Helpers;

        onInputChangeForNumber(event);

        const clean_tc = convertToFloat(event.target.value);

        setFormState(prev => ({
            ...prev,
            clean_movimiento_tipo_cambio: clean_tc,
        }));

        if (formState.movimiento_moneda && formState.clean_movimiento_monto) {
            _calculateTotalQuetzalsAndDollars({
                refSetFormState: setFormState,
                movimiento_moneda: formState.movimiento_moneda,
                clean_movimiento_monto: formState.clean_movimiento_monto,
                clean_movimiento_tipo_cambio: clean_tc,
                formatMoney,
            });
        }
    };

    const handleClickPrintReport = () => {
        const { FilterForm } = Forms
        const { formState } = FilterForm

        const { startDate, endDate, idcaja, movimiento_tipo } = formState

        if (!startDate) {
            alertMessage({ flag: 'FAIL', message: 'No es posible descargar sin especificar la fecha de inicio para generar el reporte' })
            return
        }

        if (!endDate) {
            alertMessage({ flag: 'FAIL', message: 'No es posible descargar sin especificar la fecha de fin para generar el reporte' })
            return
        }

        const { fetchTransactionsReport } = FetchData
        fetchTransactionsReport.setParamsToSearch({
            startDate,
            endDate,
            idcaja,
            movimiento_tipo
        })
        fetchTransactionsReport.executeFetch()

        abrirModal('', 'VISOR DE REPORTE', 'ReportViewer', {})
    }

    const onSubmitForm = async (e) => {

        e.preventDefault()

        const { fetchSpecificTransactionCashier } = FetchData
        const { setLoadingSubmitForm } = globalStates
        const { FormScreen, FilterForm } = Forms
        const { formState, onResetForm } = FormScreen

        if (
            formState.movimiento_tipo === ''
            || formState.idcaja === ''
            || formState.clean_movimiento_monto === ''
            || formState.movimiento_moneda === ''
            || formState.clean_movimiento_tipo_cambio === ''
            || formState.clean_movimiento_quetzales === ''
            || formState.clean_movimiento_dolares === ''
            || formState.movimiento_observaciones === ''
        ){
            alertMessage({
                flag: false,
                message: 'Para registrar la transacción debe completar todos los campos del formulario'
            })
            return
        }

        const _dataBody = {
            idmovimiento: formState.idmovimiento,
            idcaja: formState.idcaja,
            movimiento_fecha: formState.movimiento_fecha,
            movimiento_usuario: user.username,
            movimiento_tipo: formState.movimiento_tipo,

            movimiento_monto: formState.clean_movimiento_monto,
            movimiento_moneda: formState.movimiento_moneda,
            movimiento_tipo_cambio: formState.clean_movimiento_tipo_cambio,
            movimiento_quetzales: formState.clean_movimiento_quetzales,
            movimiento_dolares: formState.clean_movimiento_dolares,

            movimiento_observaciones: formState.movimiento_observaciones,
            user: user.username
        }

        const { startDate, endDate, idcaja, movimiento_tipo } = FilterForm.formState

        console.log('[useActions][onSubmitForm] _dataBody ', _dataBody)
        setLoadingSubmitForm(true)
        await marvarApi.post(`/cash-movement/create-cash-movement`, _dataBody)
            .then(({ data }) => {

                console.log('data ::: ', data)

                alertMessage(data)

                if (data.flag === 'FAIL'){
                    setLoadingSubmitForm(false)
                    return
                }
                
                onResetForm()
                _fetchTransactionByFilter({ startDate, endDate, idcaja, movimiento_tipo })
                handleClickHideForm()
                setLoadingSubmitForm(false)

                fetchSpecificTransactionCashier.setParamsToSearch({
                    idmovimiento: data.rows.insertId,
                    printTicketFlag: true
                })
                fetchSpecificTransactionCashier.executeFetch()

                abrirModal('', 'VISOR DE REPORTE', 'ReceiptViewer', {})

            })
            .catch(error => {
                setLoadingSubmitForm(false)
                console.log('API ERROR: ', error)
            })
    }

    useEffect(() => {
        const { FilterForm } = Forms
        const { formState } = FilterForm

        // dispara al entrar con defaults
        _fetchTransactionByFilter(formState)

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleClickPrintReceipt = async (idmovimiento) => {

        const { fetchSpecificTransactionCashier } = FetchData
        const { FormScreen } = Forms
        
        fetchSpecificTransactionCashier.setParamsToSearch({
            idmovimiento: idmovimiento,
            printTicketFlag: true
        })
        fetchSpecificTransactionCashier.executeFetch()

        abrirModal('', 'VISOR DE REPORTE', 'ReceiptViewer', {})

    }

    return Object.freeze({
        abrirModal,
        cerrarModal,
        handleClickShowForm,
        handleClickHideForm,
        handleClickOpenEditableForm,
        handleClickFetchSpecificTransactionCashier,
        handleChangeStartDate,
        handleChangeEndDate,
        handleChangeIdCaja,
        handleChangeMovimientoTipo,
        handleChangeAmount,
        handleChangeTypeCurrency,
        handleChangeExchangeRate,
        handleClickPrintReport,
        handleClickPrintReceipt,
        onSubmitForm
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {

    if (res) {
        const { flag, message } = res
        if (flag === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}